"use client"
/* */
const getContainerBreakpointSizeClassName = (containerBreakpointSize) => `container-breakpoint-size-${containerBreakpointSize}`;

export { getContainerBreakpointSizeClassName };
//# sourceMappingURL=getContainerBreakpointSizeClassName.mjs.map
